<template></template>

<script>
import liff from "@line/liff";

export default {
  async created() {
    if (!liff.isInClient()) {
      if (!liff.isLoggedIn()) {
        liff.login({ redirectUri: window.location.href });
      }
    }

    const profile = await liff.getProfile();
    
    window.location = `${process.env.VUE_APP_WEB_URL}/user/assessment/report/liff?lineId=${profile.userId}`;
  },
};
</script>
